module.exports = __webpack_public_path__ + "img/54.f43ee1d8.png";